var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-' + _vm.name,{tag:"component",staticClass:"icon",attrs:{"w":_vm.width,"h":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }